<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title" id="exampleModalLabel1">
      Ajustar limites de conexiones
    </h4>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      mat-dialog-close
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <form [formGroup]="form">
      <div class="row">
        <div class="col-12">
          <mat-form-field style="width: 100%;">
            <mat-label>Ingrese su numero de conexiones</mat-label>
            <input
              type="text"
              formControlName="cantidad"
              matInput
              placeholder="Ingrese su numero de conexiones"
            />
            <mat-error *ngIf="form.get('cantidad').hasError('required')"
              >la cantidad es <strong>requerida </strong></mat-error
            >
            <mat-error *ngIf="form.get('cantidad').hasError('pattern')"
              >Solo se adminten <strong>numeros </strong></mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <!-- Nombre -->

      <br />
    </form>
    <button
      *ngIf="editarConexiones"
      (click)="createConexion()"
      class="btn btn-info waves-effect float-right"
      [disabled]="form.status != 'VALID'"
    >
    <i class="far fa-save"></i>
      Guardar
    </button>
  </div>
</div>
